(() => {
    let cardCount = 1;
    const maxCards = 5;
        let fifthDividerAdded = false;

    

    const init = () => {
        const root = document.querySelector('.form-crm-root');
        if (!root) return;

        const gridFieldSelector =
        '.form-crm--input-block.form-crm--grid-6, ' +
        '.form-crm--input-block.form-crm--grid-4, ' +
        '.form-crm--input-block.form-crm--grid-12.radio-input-container, ' +
        '.form-crm--input-block.price-input-container';

        const isGroupField = (el) => {
            return el?.matches(gridFieldSelector);
        };

        let isGrouping = false;

        document.addEventListener('click', (e) => {
            const edit = e.target.closest('.preview-card__edit');

            if (!edit) return;

            e.preventDefault();

            const targetIndex = edit.dataset.previewCardEdit;

            const allFields = document.querySelectorAll('[data-index]');
            const selectedFields = document.querySelectorAll(
                `[data-index="${targetIndex}"]`
            );

            if (!selectedFields.length) return;

            document.body.classList.remove('step-break');
            document.body.classList.remove('step-1-validated');
            document.body.classList.add('edit-fields-open');

            allFields.forEach((field) => {
                field.style.display = 'none';
            });

            selectedFields.forEach((field) => {
                field.style.display = 'block';
            });
        });

        // -----------------------------
        // Upload Labels
        // -----------------------------
        const loadUploadLabels = () => {
            const labels = root.querySelectorAll('.form-crm--file-upload label');

            labels.forEach(label => {
                if (label.dataset.processed) return;

                label.dataset.processed = 'true';
                label.innerHTML = 'Upload file';
            });
        };

        // const checkRadioInputs = () => {
        //     const radios = document.querySelectorAll('.form-crm-default--radio');

        //     radios.forEach((radio) => {

        //         radio.parentElement.classList.add('radio-input-container');

        //         if (radio.parentElement.previousElementSibling) {
        //             radio.parentElement.previousElementSibling.classList.add(
        //                 'price-input-container'
        //             );
        //         }

        //         const firstRadio = radio.querySelector('input[type="radio"]');

        //         if (!firstRadio) return;

        //         // Don't repeatedly initialise the same radio
        //         if (firstRadio.dataset.defaultSelected === 'true') return;

        //         // If CRM already selected something, leave it alone
        //         if (radio.querySelector('input[type="radio"]:checked')) {
        //             firstRadio.dataset.defaultSelected = 'true';
        //             return;
        //         }

        //         firstRadio.dataset.defaultSelected = 'true';

        //         // requestAnimationFrame(() => {
        //             setTimeout(() => {
        //                 firstRadio.click();
        //             }, 3000);
        //         // });
        //     });
        // };

        const renderHeader = () => {
            const stepOneText = document.querySelector('.form-crm-default--header-h1');
            const stepOneParagraph = document.querySelector('.form-crm-default--paragraph');
            const container = document.querySelector('.form-crm--card-container');

            if (!container) return;

            // Don't create another header if one already exists
            if (container.parentNode.querySelector('.form-header-container')) {
                return;
            }

            const headerContainer = document.createElement('div');
            headerContainer.classList.add('form-header-container');

            if (stepOneText) {
                const heading = document.createElement('h1');
                heading.innerText = stepOneText.innerText;
                headerContainer.appendChild(heading);
            }

            if (stepOneParagraph) {
                const paragraph = document.createElement('p');
                paragraph.innerText = stepOneParagraph.innerText;
                headerContainer.appendChild(paragraph);
            }

            container.parentNode.insertBefore(headerContainer, container);
        };

        const renderHeaderStepTwo = () => {
            const container = document.querySelector('.form-crm--card-container');

            if (!container) return;

            // Don't create another header if one already exists
            if (container.parentNode.querySelector('.form-header-container-step-2')) {
                return;
            }

            const headerContainer = document.createElement('div');
            headerContainer.classList.add('form-header-container-step-2');

            const heading = document.createElement('h1');
            heading.innerText = "Step 2: Upload";
            headerContainer.appendChild(heading);

            const paragraph = document.createElement('p');
            paragraph.innerText = "We'll email your offer within 24 hours.";
            headerContainer.appendChild(paragraph);

            container.parentNode.insertBefore(headerContainer, container);
        };


        const checkRadioInputs = () => {
            const radios = document.querySelectorAll('.form-crm-default--radio');

            radios.forEach((radio) => {

                radio.parentElement.classList.add('radio-input-container');

                const priceInputContainer =
                    radio.parentElement.previousElementSibling;

                if (priceInputContainer) {
                    priceInputContainer.classList.add('price-input-container');
                }

                const radioInputs = radio.querySelectorAll(
                    'input[type="radio"]'
                );

                if (!radioInputs.length) return;

                const updateCurrencyClass = () => {
                    const checkedRadio = radio.querySelector(
                        'input[type="radio"]:checked'
                    );

                    if (!checkedRadio || !priceInputContainer) return;

                    const label = checkedRadio
                        .closest('.form-crm-default--radio-item')
                        ?.querySelector(
                            '.form-crm-default--radio-item-label'
                        );

                    if (!label) return;

                    const currencyText = label.textContent.trim();

                    // Remove existing currency classes
                    priceInputContainer.classList.forEach((className) => {
                        if (className.startsWith('currency-')) {
                            priceInputContainer.classList.remove(className);
                        }
                    });

                    // Determine currency from label text
                    if (currencyText.includes('GBP')) {
                        priceInputContainer.classList.add('currency-gbp');
                    }

                    if (currencyText.includes('USD')) {
                        priceInputContainer.classList.add('currency-usd');
                    }
                };

                // Listen to all radio options
                radioInputs.forEach((input) => {
                    input.addEventListener('change', updateCurrencyClass);
                });

                // Set initial currency class
                updateCurrencyClass();

                // Don't repeatedly initialise the same radio
                const firstRadio = radioInputs[0];

                if (firstRadio.dataset.defaultSelected === 'true') return;

                // If CRM already selected something, leave it alone
                if (radio.querySelector('input[type="radio"]:checked')) {
                    firstRadio.dataset.defaultSelected = 'true';
                    return;
                }

                firstRadio.dataset.defaultSelected = 'true';

                setTimeout(() => {
                    firstRadio.click();
                }, 3000);
            });
        };

        // -----------------------------
        // Upload Previews
        // -----------------------------
        const loadUploadPreviews = () => {

            const inputs = root.querySelectorAll('input[type="file"]');

            inputs.forEach(input => {

                if (input.dataset.previewBound) return;

                input.dataset.previewBound = 'true';

                input.addEventListener('change', () => {

                    const file = input.files[0];
                    if (!file) return;

                    const field = input.closest('.form-crm--input-block');

                    const observer = new MutationObserver(() => {

                        const buttonContainer = field.querySelector(
                            '.form-crm-default--file-detail-container'
                        );

                        if (!buttonContainer) return;

                        // Stop watching once found
                        observer.disconnect();

                        const existing = buttonContainer.querySelector('.upload-preview');

                        if (existing) {
                            existing.remove();
                        }

                        const img = document.createElement('img');

                        img.classList.add('upload-preview__image');
                        img.src = URL.createObjectURL(file);
                        img.alt = file.name;

                        buttonContainer.appendChild(img);

                    });


                    observer.observe(field, {
                        childList: true,
                        subtree: true
                    });

                });

            });

        };

        const checkStep = () => {
            let container = document.querySelector( '.form-crm-react-root' );
            let header = document.querySelector( '.form-crm-default--header-h1' );

            if( header.innerHTML === 'Step 2: Submit' ) {
                container.classList.add( 'step-3' );
                container.classList.remove( 'step-1' );
                document.body.classList.remove( 'step-1-validated' );
                document.body.classList.remove( 'step-break' );
            }

            if( header.innerHTML === 'Step 1: Upload' ) {
                container.classList.add( 'step-1' );
                container.classList.remove( 'step-3' );
            }
        }

        const resetStepOneFields = () => {
            const fields = document.querySelectorAll(
                '.form-crm--input-block.form-crm--grid-6'
            );

            fields.forEach(field => {
                field.style.display = 'none';
            });

            // Show the first 12 fields (your first card)
            let count = 0;

            fields.forEach(field => {
                if (count < 16) {
                    field.style.display = '';
                    count++;
                }
            });
        };

        // -----------------------------
        // Step Watcher
        // -----------------------------
        const watchStepContainer = () => {
            const stepContainer = root.querySelector('.form-crm--card-container');
            if (!stepContainer) return;

            let previousStep = null;

            const observer = new MutationObserver(() => {
                // console.log('👣 Step changed:', stepContainer.className);
                checkStep();
                groupStepOneElements();

                const header = document.querySelector(
                    '.form-crm-default--header-h1'
                );

                const currentStep = header?.innerHTML.trim();

                // Only run when we TRANSITION back into Step 1
                if (
                    currentStep === 'Step 1: Upload' &&
                    previousStep !== null &&
                    previousStep !== 'Step 1: Upload'
                ) {
                    // resetStepOneFields();
                    console.log("Moved back");

                    document.body.classList.add( 'step-break', 'step-1-validated' )
                    let fields = document.querySelectorAll( '[data-index]' );
                    fields.forEach((field) => {
                        field.style.display = 'none';
                    });
                }

                previousStep = currentStep;
                
                const formEls = Array.from(
                    stepContainer.querySelectorAll(
                        '.form-crm--input-block.form-crm--grid-6:not([style*="display: none"]), ' +
                        '.form-crm--input-block.form-crm--grid-4:not([style*="display: none"]), ' +
                        '.form-crm--input-block.form-crm--grid-12.radio-input-container:not([style*="display: none"])'
                    )
                );
                
                console.log(formEls);
                const tenthField = formEls[13]; // zero-indexed, so 10th item
                console.log(tenthField);
                let nextAnchor;

                if (tenthField) {
                    nextAnchor = tenthField.nextElementSibling;

                    console.log(nextAnchor);

                    if (
                        nextAnchor &&
                        nextAnchor.classList.contains('form-crm--grid-12') &&
                        nextAnchor.classList.contains('group-anchor-hidden')
                    ) {
                        console.log('Found hidden group anchor:', nextAnchor);
                    }
                }

                // console.log(nextAnchor);
                let saveEl = nextAnchor.querySelector( '.group-anchor' );
                checkInputGroup(Array.from(formEls), saveEl);
            });

            observer.observe(stepContainer, {
                attributes: true,
                attributeFilter: ['class'],
                subtree: true
            });
        };

        const checkFileUploadFields = () => {
            let files = document.querySelectorAll( 'input[type="file"]' );
            files.forEach((file, i) => {
                console.log(i);
                file.parentElement.parentElement.classList.add( 'file-input-container-' + i );
            });
        }

        const checkInputGroup = (fields, saveEl) => {

            console.log('Checking group:', fields.length);
            console.log(saveEl);

            let container = document.querySelector( '.form-crm--form-element' );

            const allFilled = fields.every(field => {

                // File upload check
                const fileName = field.querySelector('.form-crm-default--file-name');

                if (fileName) {
                    console.log('File found:', fileName.textContent.trim());

                    return fileName.textContent.trim() !== '';
                }

                const input = field.querySelector(
                    'input:not([type="hidden"]), textarea, select'
                );

                console.log(
                    'Input:',
                    input,
                    'Value:',
                    input?.value
                );

                if (!input) return false;

                return input.value.trim() !== '';

            });

            // console.log('All filled:', allFilled);
            // console.log(saveEl);
            console.log( "Test:" + saveEl, allFilled);
            if( allFilled === true ) {
                console.log("All filled");
                let stepOne = document.querySelector( '.step-1' );
                // let saveEl = container.querySelector( ' .group-anchor' );
                let saveEl = container.querySelector( '.form-crm--input-block.form-crm--grid-6:not([style*="display: none"]) + .form-crm--grid-12 .group-anchor' );
                if( stepOne ) {
                    if (stepOne && !stepOne.classList.contains('step-1-validated')) {
                        stepOne.classList.add('step-1-validated');
                    }

                    if (saveEl && saveEl.classList.contains('group-anchor-hidden')) {
                        saveEl.classList.remove('group-anchor-hidden');
                    }
                }
            } else {
                let stepOne = document.querySelector( '.step-1' );
                // let saveEl = container.querySelector( '.group-anchor:first-of-type' );
                if( stepOne ) {
                   if (stepOne && stepOne.classList.contains('step-1-validated')) {
                        stepOne.classList.remove('step-1-validated');
                    }

                    if (saveEl && !saveEl.classList.contains('group-anchor-hidden')) {
                        saveEl.classList.add('group-anchor-hidden');
                    }
                }
            }

        };

        // -----------------------------
        // Email watcher
        // -----------------------------
        const initEmailWatcher = () => {
            const email = root.querySelector('input[type="email"]');
            if (!email) return;

            email.addEventListener('blur', () => {
                console.log('📧 Email entered:', email.value);
            });
        };

        const checkSubheading = () => {
            let subheadings = document.querySelectorAll( '.form-crm-default--header-h3' );
            // if( subheadings ) {
            console.log(subheadings);
               subheadings.forEach((subheading) => {
                console.log(subheading);
                subheading.parentElement.classList.add( 'card-heading' );
               }); 
            // }
        }

    // -----------------------------
    // GROUPING FIX (stable)
    // -----------------------------
    const groupStepOneElements = () => {

            if (isGrouping) return;

    const isGroupField = (el) => {
        return el?.matches(
            '.form-crm--input-block.form-crm--grid-6, ' +
            '.form-crm--input-block.form-crm--grid-4, ' +
            '.form-crm--input-block.form-crm--grid-12.radio-input-container, ' +
            '.form-crm--input-block.price-input-container'
        );
    };

    const dividers = document.querySelectorAll(
        '.form-crm-default--divider'
    );

    let groupIndex = 1;

    // -----------------------------------------
    // FIRST GROUP — START WITH RADIO
    // -----------------------------------------

    const firstGroupStart = document.querySelector(
        '.form-crm--input-block.form-crm--grid-12.radio-input-container'
    );

    console.log('FIRST GROUP START:', firstGroupStart);

    if (firstGroupStart) {

        let currentElement = firstGroupStart;
        let count = 0;

        while (currentElement && count < 16) {

            console.log(
                'Checking first-group element:',
                currentElement,
                'isGroupField:',
                isGroupField(currentElement)
            );

            if (isGroupField(currentElement)) {

                currentElement.dataset.index = '1';
                currentElement.dataset.groupIndex = '1';

                console.log(
                    'Assigned group 1:',
                    currentElement,
                    currentElement.dataset.index
                );

                count++;
            }

            currentElement = currentElement.nextElementSibling;
        }

        console.log(
            'FIRST GROUP COUNT:',
            count
        );
    }

        dividers.forEach((divider, i) => {

            if (divider.dataset.grouped) return;

        const fields = [];
        const target = divider.parentElement;

        if (!target) return;

        groupIndex++;

        let currentField;

        if (i === 4 && !target.nextElementSibling) {

            currentField = target.previousElementSibling;

            while (currentField && fields.length < 16) {

                if (isGroupField(currentField)) {

                    fields.unshift(currentField);

                    currentField.dataset.index = String(groupIndex);
                    currentField.dataset.groupIndex = String(groupIndex);
                }

                currentField = currentField.previousElementSibling;
            }

        } else {

            currentField = target.nextElementSibling;

            while (currentField && fields.length < 16) {

                if (isGroupField(currentField)) {

                    fields.push(currentField);

                    currentField.dataset.index = String(groupIndex);
                    currentField.dataset.groupIndex = String(groupIndex);
                }

                currentField = currentField.nextElementSibling;
            }
        }

        if (fields.length === 0) {
            return;
        }

        divider.dataset.grouped = 'true';
           
            let saveEl = document.createElement('p');
            saveEl.textContent = 'Save card';
            saveEl.className = 'group-anchor form-crm--input-block';
            saveEl.classList.add('group-anchor-hidden');
            console.log("Target:" +target);
            target.appendChild(saveEl);

            fields.forEach(field => {

                field.addEventListener('change', () => {
                    console.log('Change detected in field');

                    checkInputGroup(fields, saveEl);
                });

            });

            checkInputGroup(fields, saveEl);

                saveEl.addEventListener('click', (e) => {
                    e.preventDefault();
                        document.body.classList.add('step-1-validated');

                    const isEditing = document.body.classList.contains('edit-fields-open');
                    
                    if (isEditing) {
                        document.body.classList.remove('edit-fields-open');
                        document.body.classList.add( 'step-break' );
                    }

                    window.scrollTo(0, 0);
                    // Hide previous 10
                    let previousField = saveEl.parentElement?.previousElementSibling;
                    let count = 0;

                    while (previousField && count < 16) {

                        // if (previousField.classList.contains('form-crm--grid-6') || previousField.classList.contains('form-crm--grid-4') ) {
                        //     previousField.style.display = 'none';
                        //     count++;
                        // }

                        if (isGroupField(previousField)) {
                            previousField.style.display = 'none';
                            count++;
                        }

                        previousField = previousField.previousElementSibling;
                    }


                    // Show next 10
                    let nextField = saveEl.parentElement?.nextElementSibling;
                    count = 0;

                    while (nextField && count < 16) {

                        if (isGroupField(nextField)) {
                            nextField.style.display = '';
                            count++;
                        }

                        nextField = nextField.nextElementSibling;
                    }
                    if (!isEditing) {

                    let previewImages = document.querySelectorAll( '.form-crm--input-block.form-crm--grid-12 + .form-crm--grid-6 .upload-preview__image' );
                    let stepContainer = document.querySelector( '.form-crm--step-container' );
                    let previewCard = document.createElement('div');
                    let previewWrapper = document.createElement( 'div' );
                    let previewImageEl = document.createElement( 'img' );
                    let previewImage = document.createElement( 'figure' );
                    let previewImageWrap = document.createElement( 'div' );
                    let previewTextContainer = document.createElement( 'div' );
                    let previewTitle = document.createElement( 'p' );
                    let previewEdit = document.createElement( 'p' );
                    // previewEdit.dataset.previewCardEdit = cardCount;
                    const previewCardIndex = cardCount;

                    previewEdit.dataset.previewCardEdit = previewCardIndex;
                    previewTitle.innerHTML = 'Card ' + previewCardIndex;

                    document.body.classList.add( 'step-break' );
                    
                    previewCard.classList.add('preview-card');
                    previewWrapper.classList.add( 'preview-card__wrapper' );
                    previewImage.classList.add( 'preview-card__image' );
                    previewImageWrap.classList.add( 'preview-card__image-wrapper' );
                    previewTextContainer.classList.add( 'preview-card__text-container' );
                    previewTitle.classList.add( 'preview-card__title' );
                    previewEdit.classList.add( 'preview-card__edit' );

                    previewTitle.innerHTML = 'Card ' + cardCount;
                    previewEdit.innerHTML = 'Edit details';

                    if( previewImages[cardCount-1] ) {
                        // console.log(previewImages[cardCount-1]);
                        previewImageEl.src = previewImages[cardCount-1].src;
                    }

                    previewImageWrap.appendChild( previewImageEl );
                    previewImage.appendChild( previewImageWrap );
                    previewWrapper.appendChild( previewImage );
                    previewTextContainer.appendChild( previewTitle );
                    previewTextContainer.appendChild( previewEdit );
                    previewWrapper.appendChild( previewTextContainer );
                    previewCard.appendChild( previewWrapper );

                    if( !isEditing ) {
                        cardCount++;
                    }

                    let buttonContainer = document.querySelector( '.form-crm--button-container' );
                    let pagination = document.createElement( 'div' );
                    pagination.innerHTML = "+ Add Another Card 2 / 5";
                    pagination.classList.add( 'card-pagination' );


                    
                    saveEl.classList.add( 'group-anchor-hidden' );
                    document.body.classList.remove( 'next-step' );
                    document.body.classList.add( 'step-1-validated' );

                    if( !document.querySelector( '.card-pagination' ) ) {
                        buttonContainer.parentNode.insertBefore(
                            pagination,
                            buttonContainer
                        );

                        let currentCard = 2;
                        const maxCards = 5;
                        console.log(currentCard);

                        pagination.addEventListener('click', () => {
                            document.body.classList.remove( 'step-break' );
                            document.body.classList.remove('step-1-validated');
                            document.body.classList.add( 'next-step' );

                            if (currentCard < maxCards) {
                                currentCard++;

                                pagination.textContent = `+ Add Another Card ${currentCard} / ${maxCards}`;
                            }

                        });
                    }
                    const cardContainer = document.querySelector('.form-crm--card-container');

                    if( !isEditing ) {
                        if (cardContainer) {
                            cardContainer.before(previewCard);

                            const previewCards = document.querySelectorAll('.preview-card');

                            if (previewCards.length === 5) {
                                document.body.classList.add('five-preview-cards');
                            } else {
                                document.body.classList.remove('five-preview-cards');
                            }

                            // let cardEdit = document.querySelectorAll( '.preview-card__edit' );
                            // cardEdit.forEach((edit) => {
                            //     edit.addEventListener( 'click', (e) => {
                            //         e.preventDefault();

                            //         let targetIndex = e.target.dataset.previewCardEdit;
                            //         let allFields = document.querySelectorAll( '[data-index]' );
                            //         let selectedFields = document.querySelectorAll( '[data-index="'+targetIndex+'"]' );

                            //         if( selectedFields ) {
                            //             document.body.classList.remove( 'step-break' );
                            //             document.body.classList.remove( 'step-1-validated' );
                            //             document.body.classList.add( 'edit-fields-open' );

                            //             allFields.forEach((field) => {
                            //                 field.style.display = 'none';
                            //             });

                            //             selectedFields.forEach((field) => {
                            //                 field.style.display = 'block';
                            //             });
                            //         }
                            //     });
                            // });
                        }
                    }
                }
                    // document.body.classList.remove( 'edit-fields-open' );

                    // if( document.querySelector( '.edit-fields-open' ) ) return;


                });


                // Hide following fields initially
                let hideField = divider.parentElement?.nextElementSibling;

            while (hideField) {

                if (isGroupField(hideField)) {
                    hideField.style.display = 'none';
                }

                hideField = hideField.nextElementSibling;
            }

            });

        };
        // -----------------------------
        // ROOT OBSERVER
        // -----------------------------
        let stepWatcherStarted = false;

        const rootObserver = new MutationObserver(() => {

            loadUploadLabels();
            loadUploadPreviews();

            checkRadioInputs();   
            groupStepOneElements();  

            checkStep();
            checkSubheading();
            checkFileUploadFields();
            renderHeader();
            renderHeaderStepTwo();

            if (!stepWatcherStarted) {
                const stepContainer = root.querySelector('.form-crm--card-container');

                if (stepContainer) {
                    watchStepContainer();
                    stepWatcherStarted = true;
                }
            }
        });

        rootObserver.observe(root, {
            childList: true,
            subtree: true
        });

        // -----------------------------
        // INIT CALLS
        // -----------------------------
        loadUploadLabels();
        loadUploadPreviews();
        initEmailWatcher();

        checkRadioInputs();   
        groupStepOneElements();  

        checkSubheading();
        checkFileUploadFields();
        renderHeader();
        renderHeaderStepTwo();
    };

    // Run when DOM is ready
    document.addEventListener('DOMContentLoaded', init);

})();